<template>
    <div class="relative">
        <!-- Dropdown Trigger -->
        <div
            class="cursor-pointer rounded px-4 py-3 bg-white text-f5 flex flex-row gap-4 items-center shadow-md"
            @click="toggleDropdown"
        >
            Order by:
            <span class="font-bold">
                {{ selectedLabel }}
            </span>
            <i
                class="fa fa-chevron-down ml-2 text-primary"
                :class="{ 'transform rotate-180': dropdownOpen }"
            ></i>
        </div>

        <!-- Dropdown Options -->
        <ul
            v-show="dropdownOpen"
            class="absolute mt-1 w-full bg-white rounded shadow-md z-10 py-4 px-6 flex flex-col gap-6"
        >
            <li
                v-for="option in options"
                :key="option.value"
                class="hover:text-primary cursor-pointer flex flex-row items-center justify-between"
                @click="selectOption(option)"
            >
                {{ option.label }}
                <i
                    v-if="option.value === modelValue"
                    class="fas fa-check text-primary float-right"
                ></i>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: String,
            default: "",
        },
    },
    emits: ["update:modelValue"],
    data() {
        return {
            dropdownOpen: false,
            options: [
                { value: "", label: "Relevance" },
                { value: "ArtikelnrAsc", label: "Article number asc" },
                { value: "ArtikelnrDesc", label: "Article number desc" },
                { value: "ListenpreisAsc", label: "Price asc" },
                { value: "ListenpreisDesc", label: "Price desc" },
            ],
        };
    },
    computed: {
        selectedLabel() {
            const selectedOption = this.options.find(
                (option) => option.value === this.modelValue,
            );
            return selectedOption ? selectedOption.label : "Select an option";
        },
    },
    methods: {
        toggleDropdown() {
            this.dropdownOpen = !this.dropdownOpen;
        },
        selectOption(option) {
            this.$emit("update:modelValue", option.value);
            this.dropdownOpen = false;
        },
    },
};
</script>
